"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'route.company.list': 'Companies',
    'route.company.create': 'Add Company',
    'route.company.edit': 'Edit Company',
};
